import { GoJsModelProperties, hasDiagramDarkMode } from '@y42/gojs';
import { Binding, GraphObject, Group, Node, Part } from 'gojs';
import {
  DataLineageNodeBinding,
  DataLineageThemeColors,
  DataLineageUINode,
} from '../../../../../../state/data-lineage-diagram';
import { shouldHighlight } from '../../../utils/data-lineage-highlight';

export const groupExpandedBinding = () => new Binding('isSubGraphExpanded').makeTwoWay();

export const groupBackgroundBinding = () =>
  new Binding('fill', '', (node: DataLineageUINode, diagramPart: Part) => {
    const hasDarkMode = hasDiagramDarkMode(diagramPart.diagram);
    const hasReadPermission = node[DataLineageNodeBinding.HasReadPermission];

    if (hasDarkMode) {
      return hasReadPermission ? DataLineageThemeColors.Dark.GroupFill : DataLineageThemeColors.Dark.GroupFillDisabled;
    }

    return hasReadPermission ? DataLineageThemeColors.Light.GroupFill : DataLineageThemeColors.Light.GroupFillDisabled;
  });

export const groupStrokeBinding = () =>
  new Binding('stroke', '', (object: GraphObject, diagramPart: Part) => {
    const group = object.part as Group;
    const groupData = group?.data as DataLineageUINode | undefined;

    const hasDarkMode = diagramPart.diagram?.model.modelData[GoJsModelProperties.HasDarkMode];

    if (!groupData?.[DataLineageNodeBinding.Name]) {
      return DataLineageThemeColors.Transparent;
    }

    const filterHighlights = object.diagram?.model.modelData[DataLineageNodeBinding.FilterHighlights] || [];
    const children = object.diagram?.findNodesByExample({ group: group.data.key });
    const hasAnyHighlightedChild = children?.any((part) => shouldHighlight(filterHighlights, part as Node));

    if (group.isHighlighted) {
      return hasDarkMode
        ? DataLineageThemeColors.Dark.Stroke.Highlighted
        : DataLineageThemeColors.Light.Stroke.Highlighted;
    }

    if (groupData?.[DataLineageNodeBinding.Active]) {
      return hasDarkMode ? DataLineageThemeColors.Dark.Stroke.Active : DataLineageThemeColors.Light.Stroke.Active;
    }

    if (group.isSelected) {
      return hasDarkMode ? DataLineageThemeColors.Dark.Stroke.Selected : DataLineageThemeColors.Light.Stroke.Selected;
    }

    if (groupData?.[DataLineageNodeBinding.PathSelection]) {
      return hasDarkMode
        ? DataLineageThemeColors.Dark.Stroke.PathSelection
        : DataLineageThemeColors.Light.Stroke.PathSelection;
    }

    if (filterHighlights.length > 0 && (hasAnyHighlightedChild || shouldHighlight(filterHighlights, group as Node))) {
      return hasDarkMode
        ? DataLineageThemeColors.Dark.Stroke.FilterHighlight
        : DataLineageThemeColors.Light.Stroke.FilterHighlight;
    }

    return hasDarkMode ? DataLineageThemeColors.Dark.GroupStroke : DataLineageThemeColors.Light.GroupStroke;
  }).ofObject();
